import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { NEWS_POSTS_PER_PAGE } from '@constants'

import s from './Pagination.module.css'

// TODO: Setup routing
function Pagination({ pagination = {}, currentPage = 1, className = '' }) {
  if (!pagination || (!pagination?.hasPrevious && !pagination?.hasMore))
    return null

  const router = useRouter()
  if (!pagination) return null

  const pageNumbersShown = 6
  const diff = currentPage % pageNumbersShown
  let activePageNumber = diff === 1 ? 0 : diff - 1
  if (diff === 0) activePageNumber = pageNumbersShown - 1

  const offset = currentPage - (diff === 0 ? pageNumbersShown : diff)
  const pageTotal = Math.ceil(pagination?.total / NEWS_POSTS_PER_PAGE)

  // todo: this could be filled from a Set or similar mechanic, filling from 1 to pageNumbersShown (+offset)
  const pageNumbers = [
    offset + 1,
    offset + 2,
    offset + 3,
    offset + 4,
    offset + 5,
    offset + 6,
    offset + 7,
  ].filter((p) => p <= pageTotal)

  // const previousLink = (() => {
  //   let url = `/${router.query?.site}/news/`
  //   if (router.query?.categorySlug) url += router.query?.categorySlug
  //   else if (currentPage > 2) url += 'archive'
  //   if (currentPage > 2) url += `/${currentPage - 1}`
  //   return url
  // })()

  const pageLink = (page) => {
    const url = `/${router.query?.site}/news`
    return page
      ? `${url}/${router.query?.categorySlug || 'archive'}/${page}`
      : url
  }
  const handlePrevBtn = () => {
    router.push(pageLink())
  }

  const handleNextBtn = () => {
    router.push(pageLink(pageTotal - 1))
  }

  const handlePageBtn = (page) => {
    const setPage = page === 1 ? null : page
    router.push(pageLink(setPage))
  }

  return (
    <div className={classNames(s.container, className)}>
      <button
        type="button"
        className={classNames(s.btn, {
          [s.btnActive]: pagination?.hasPrevious,
        })}
        onClick={handlePrevBtn}
      />
      {pageNumbers.map((p) => (
        <button
          key={p}
          type="button"
          className={classNames(s.page, {
            [s.pageCurrent]: pageNumbers[activePageNumber] === p,
          })}
          onClick={() => handlePageBtn(p)}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        className={classNames(s.btn, s.btnFlipped, {
          [s.btnActive]: pagination?.hasMore,
        })}
        onClick={handleNextBtn}
      />
    </div>
  )
}

Pagination.propTypes = {
  pagination: PropTypes.object,
  currentPage: PropTypes.number,
  className: PropTypes.string,
}

export default Pagination
